import { defineModel } from "../define-model";

/** One per workspace (`id` = workspace id). Read-only; every ledger write on the server announces it. */
export type CreditBalance = {
	id: string;
	workspaceId: string;
	balanceMillicredits: number;
	/** Plan credits (spent first, expire above the rollover cap). The rest are pack credits. */
	includedMillicredits: number;
	autoTopUpEnabled: boolean;
	autoTopUpThresholdMillicredits: number;
	autoTopUpPackId: string | null;
	autoTopUpPending: boolean;
	autoTopUpError: string | null;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		creditBalance: CreditBalance;
	}
}

export const model = defineModel({ name: "creditBalance", load: "eager" });
